"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var IdentityInfo_1 = __importDefault(require("../IdentityInfo"));
var SingleSearch_1 = __importDefault(require("../SingleSearch"));
var styles_1 = require("./styles");
var prism_icons_1 = require("@octanner/prism-icons");
var identitySearch_1 = require("./identitySearch");
var react_i18next_1 = require("react-i18next");
var SearchExpand = function (_a) {
    var searchOpen = _a.searchOpen, handleSearchOpen = _a.handleSearchOpen, _b = _a.routerObj, routerPush = _b.routerPush, routerRoutes = _b.routerRoutes, testRoute = _b.testRoute;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _c = __read((0, react_1.useState)(''), 2), searchText = _c[0], setSearchText = _c[1];
    var identitySearchQuery = (0, identitySearch_1.useIdentitySearch)(searchText);
    var searchOptions = (identitySearchQuery === null || identitySearchQuery === void 0 ? void 0 : identitySearchQuery.data) || [];
    var handleClose = function () {
        setSearchText('');
        handleSearchOpen(false);
    };
    var selectIdentity = function (_, identity) {
        if (typeof identity !== 'string') {
            var url = "/profile/".concat(identity.identityUuid);
            if (routerPush && routerRoutes.some(testRoute(url))) {
                routerPush(url);
            }
            else {
                window.location.assign(url);
            }
        }
        handleClose();
    };
    if (!searchOpen) {
        return (react_1.default.createElement(styles_1.HeaderCell, null,
            react_1.default.createElement(styles_1.SearchButtonIcon, { color: "secondary", "aria-label": t('prism-header:search-people', 'Search people'), onClick: function () { return handleSearchOpen(true); }, sx: styles_1.iconButtonOverride, "data-testid": "search-icon" },
                react_1.default.createElement(prism_icons_1.Search, { color: "secondary" }))));
    }
    return (react_1.default.createElement(SingleSearch_1.default, { options: searchOptions, filterOptions: function (option) { return option; }, onChange: function (e, val) {
            selectIdentity(e, val);
            handleClose();
        }, "data-testid": "search-cc-header", loading: identitySearchQuery === null || identitySearchQuery === void 0 ? void 0 : identitySearchQuery.loading, placeholder: t('prism-header:search-people', 'Search people'), onInputChange: function (e, _, reason) {
            if (reason === 'input') {
                setSearchText(e.target.value);
            }
            else if (reason == 'clear') {
                handleClose();
            }
        }, onBlur: function () {
            handleClose();
        }, inputValue: searchText, sx: styles_1.SingleSearchStyles, renderOption: function (props, option) { return (react_1.default.createElement("li", __assign({}, props),
            react_1.default.createElement(IdentityInfo_1.default, { identity: option, color: "secondary" }))); } }));
};
exports.default = SearchExpand;
//# sourceMappingURL=SearchExpand.js.map